import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { NavbarComponent } from './component/navbar/navbar.component';
import { TranslateModule} from '@ngx-translate/core';
import { BuscarCasoComponent } from './component/forms/buscar-caso/buscar-caso.component';
import { FormsModule } from '@angular/forms';
import { AgregarPersonasComponent } from './component/forms/agregar-personas/agregar-personas.component';
import { BuscarPersonaComponent } from './component/forms/buscar-persona/buscar-persona.component';
import { EvaluationMenuComponent } from './component/evaluation-menu/evaluation-menu.component';
import { FactorsComponent } from './component/factors/factors.component';
import { TransaccionesClienteComponent } from './component/forms/transacciones-cliente/transacciones-cliente.component';
import { AddcaseGeneralDataComponent } from '../pld/add-case/component/addcase-general-data/addcase-general-data.component';
import { AddcaseTransactionsComponent } from '../pld/add-case/component/addcase-transactions/addcase-transactions.component';
import { DetailOperacionesComponent } from '../pld/detail-case-management/detail-operaciones/detail-operaciones/detail-operaciones.component'
import { MiPerfilPopupComponent } from './mi-perfil/mi-perfil-popup/mi-perfil-popup.component';
import { MiPerfilComponent} from './mi-perfil/mi-perfil/mi-perfil.component';
import { SoporteComponent } from './mi-perfil/soporte/soporte.component';
import { AcercaDeComponent } from './mi-perfil/acerca-de/acerca-de.component';
import { ManualUsuarioComponent } from './mi-perfil/manual-usuario/manual-usuario.component';
import { PreguntasFrecuentesComponent } from './mi-perfil/preguntas-frecuentes/preguntas-frecuentes.component';
import { DynamicTableModule } from '@spot-utils/dynamic-table';

@NgModule({
	imports: [RouterModule, CommonModule, TranslateModule, FormsModule,DynamicTableModule],
	declarations: [
		SidebarComponent,
		NavbarComponent,
		BuscarCasoComponent,
		AgregarPersonasComponent,
		BuscarCasoComponent,
		BuscarPersonaComponent,
		TransaccionesClienteComponent,
		EvaluationMenuComponent,
		FactorsComponent,
		AddcaseGeneralDataComponent,
		AddcaseTransactionsComponent,
		DetailOperacionesComponent,
    	MiPerfilPopupComponent,
		MiPerfilComponent,
		SoporteComponent,
		AcercaDeComponent,
		ManualUsuarioComponent,
		PreguntasFrecuentesComponent
	],
	exports: [
		SidebarComponent,
		NavbarComponent,
		TranslateModule,
		BuscarCasoComponent,
		AgregarPersonasComponent,
		BuscarPersonaComponent,
		TransaccionesClienteComponent,
		EvaluationMenuComponent,
		FactorsComponent,
		AddcaseGeneralDataComponent,
		AddcaseTransactionsComponent,
		DetailOperacionesComponent,
		MiPerfilPopupComponent,
		MiPerfilComponent,
		SoporteComponent,
		AcercaDeComponent,
		ManualUsuarioComponent,
		PreguntasFrecuentesComponent
	],
})
export class SharedModule {}
